<template>
    <div>
       

      
    </div>
</template>
<script>
export default {
    data() {
        return {
           
        };
    },
  
    created() {
        const that = this;
       
    },
    methods: {
       
        },
    
};
</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// header1.vue?2209c0d6